import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { getColor } from '../../styling/mixins/colors';
import OrderDetail from '../OrderDetail/OrderDetail';

const StyledOrderConfirmationWrapper = styled.div``;

const GlobalOrderConfirmationStyling = createGlobalStyle`
body {
  background-color: ${getColor('grey', 100)};
}
`;

const OrderConfirmation = ({ title, text, order, extraText }) => {
  return (
    <StyledOrderConfirmationWrapper>
      {order && (
        <OrderDetail
          isConfirmation={true}
          order={order}
          confirmationTitle={title}
          confirmationText={text}
          confirmationExtraText={extraText}
        />
      )}
      <GlobalOrderConfirmationStyling />
    </StyledOrderConfirmationWrapper>
  );
};

export default OrderConfirmation;
